import Header from "./header/Header";
import Footer from "./footer/Footer";

export function DashboardLayout({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`flex flex-col min-h-screen ${className}`}>
      <Header />
      {children}
      <Footer />
    </div>
  );
}
